import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Modal, Form, Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import config from '../../config';

const ModalMahasiswa = ({
  show, onHide,
}) => {
  const [statusKonfirm, setStatusKonfirm] = useState(false);
  const [npm, setNPM] = useState();
  const [prodi, setProdi] = useState('S1 Reguler Ilmu Ekonomi');
  const [angkatan, setAngkatan] = useState();

  useEffect(() => () => {
    setNPM();
    setProdi('S1 Reguler Ilmu Ekonomi');
    setAngkatan();
    setStatusKonfirm(false);
  }, [show]);

  const handleSubmit2 = () => {
    const formData = { npmnip: npm, prodi, angkatan };
    axios.post(`${config.API_BASE_URL}api/account/mahasiswa/`, formData, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      () => {
        onHide();
      },
    );
  };

  const handleProdi = (e) => {
    setProdi(e.target.value);
  };

  const handleAngkatan = (e) => {
    setAngkatan(e.target.value);
  };

  const handleNPM = (e) => {
    setNPM(e.target.value);
  };

  const formik = useFormik({
    initialValues: {
      npm,
      prodi,
      angkatan,
    },
    validationSchema: Yup.object({
      npm: Yup.number().required('NPM harus angka!').test('len', 'NPM terdiri dari 10 karakter!', (val) => {
        if (val) {
          return val.toString().length === 10;
        }
        return false;
      }),
      prodi: Yup.string().required('Prodi harus diisi!'),
      angkatan: Yup.number().required('Angkatan harus diisi!').min(2000, 'Angkatan adalah tahun masuk universitas!'),
    }),
    onSubmit: () => {
      setStatusKonfirm(!statusKonfirm);
    },
  });

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      data-testid="modal-data-mahasiswa"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {' '}
        </Modal.Title>
      </Modal.Header>
      {
        !statusKonfirm
          ? (
            <>
              <Modal.Body>
                <h4 className="font-20 mb-4">Data Mahasiswa</h4>

                <Form onSubmit={formik.handleSubmit} className="mb-4">
                  <Form.Group controlId="formPlaintextZeroFeedback">
                    <Form.Label column sm="4" className="font-24">NPM</Form.Label>
                    <Form.Control
                      type="number"
                      className="font-24"
                      value={npm}
                      onChange={(e) => { formik.handleChange(e); handleNPM(e); }}
                      data-testid="NPM"
                      name="npm"
                    />
                    {formik.errors.npm && formik.touched.npm && (
                      <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.npm}</div>
                    )}
                  </Form.Group>
                  <Form.Group controlId="formPlaintextFirstFeedback">
                    <Form.Label column sm="4" className="font-24">Angkatan</Form.Label>
                    <Form.Control
                      type="number"
                      className="font-24"
                      value={angkatan}
                      onChange={(e) => { formik.handleChange(e); handleAngkatan(e); }}
                      data-testid="angkatan"
                      name="angkatan"
                    />
                    {formik.errors.angkatan && formik.touched.angkatan && (
                      <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.angkatan}</div>
                    )}
                  </Form.Group>
                  <Form.Group controlId="formPlaintextZeroFeedback">
                    <Form.Label column sm="4" className="font-24">Prodi</Form.Label>
                    <Form.Control
                      as="select"
                      className="font-24"
                      value={prodi}
                      onChange={(e) => { formik.handleChange(e); handleProdi(e); }}
                      data-testid="prodi"
                      name="prodi"
                    >
                      <option>S1 Reguler Ilmu Ekonomi</option>
                      <option>S1 Reguler Manajemen</option>
                      <option>S1 Reguler Akuntansi</option>
                      <option>S1 Reguler Ilmu Ekonomi Islam</option>
                      <option>S1 Reguler Bisnis Islam</option>
                      <option>S1 Paralel Akuntansi</option>
                      <option>S1 Kelas Internasional Ilmu Ekonomi</option>
                      <option>S1 Kelas Internasional Manajemen</option>
                      <option>S1 Kelas Internasional Akuntansi</option>
                      <option>S2 Ilmu Ekonomi</option>
                      <option>S2 Ilmu Manajemen</option>
                      <option>S2 Ilmu Akuntansi</option>
                      <option>S2 Perencanaan Ekonomi dan Kebijakan Pembangunan</option>
                      <option>S2 Ekonomi Kependudukan dan Ketenagakerjaan</option>
                      <option>S3 Ilmu Ekonomi</option>
                      <option>S3 Ilmu Manajemen</option>
                      <option>S3 Ilmu Akuntansi</option>
                    </Form.Control>
                    {formik.errors.prodi && formik.touched.prodi && (
                      <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.prodi}</div>
                    )}
                  </Form.Group>
                  <div className="text-right w-100">
                    <Button
                      type="submit"
                      className="font-20 ml-2"
                      data-testid="selanjutnya"
                    >
                      Selanjutnya
                    </Button>
                  </div>
                </Form>
              </Modal.Body>
            </>
          )
          : (
            <>
              <Modal.Body>
                <h4>Form Konfirmasi</h4>
                <p>
                  Apakah Anda Ingin mengirim form ini sekarang?
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="danger"
                  onClick={() => setStatusKonfirm(!statusKonfirm)}
                  data-testid="kembali"
                >
                  Kembali
                </Button>
                <Button
                  variant="success"
                  onClick={handleSubmit2}
                  data-testid="konfirmasi"
                >
                  Konfirmasi
                </Button>
              </Modal.Footer>
            </>
          )
        }
    </Modal>
  );
};

ModalMahasiswa.defaultProps = {
  show: false,
};

ModalMahasiswa.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
};

export default ModalMahasiswa;
